<div class="afp-radio-group" [attr.aria-disabled]="disabled">
  <ng-content></ng-content>
</div>
